module.exports = __webpack_public_path__ + "img/tax.f5a1528b.png";